export function isTestEnv() {
  return (
    process.env.REACT_APP_ENV === 'TESTING' ||
    process.env.REACT_APP_ENV === 'STAGING'
  )
}
